/* tslint:disable */
/* eslint-disable */
/**
 * Universal Process API
 * Universal Process App API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BookingModeMigrationConflictResponseDto } from '../models';
// @ts-ignore
import type { DictionaryCalendarAvailabilityDto } from '../models';
// @ts-ignore
import type { DictionaryCalendarOccupancyKindDto } from '../models';
// @ts-ignore
import type { DictionaryCreationResponseDto } from '../models';
// @ts-ignore
import type { DictionaryPageableResponseDto } from '../models';
// @ts-ignore
import type { DictionaryResponseDto } from '../models';
// @ts-ignore
import type { DictionarySearchRequestDto } from '../models';
// @ts-ignore
import type { DictionaryTypeCalendarConfigurationDto } from '../models';
// @ts-ignore
import type { DictionaryTypeCalendarConfigurationRequestDto } from '../models';
// @ts-ignore
import type { DictionaryTypeDto } from '../models';
// @ts-ignore
import type { UpdateDictionaryRequestDto } from '../models';
/**
 * RestDictionaryApi - axios parameter creator
 */
export const RestDictionaryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {UpdateDictionaryRequestDto} updateDictionaryRequestDto Add dictionary request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDictionary: async (updateDictionaryRequestDto: UpdateDictionaryRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateDictionaryRequestDto' is not null or undefined
            assertParamExists('addDictionary', 'updateDictionaryRequestDto', updateDictionaryRequestDto)
            const localVarPath = `/api/dictionaries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDictionaryRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {DictionarySearchRequestDto} dictionarySearchRequestDto Processes search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDictionaries: async (page: number, pageSize: number, dictionarySearchRequestDto: DictionarySearchRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getDictionaries', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('getDictionaries', 'pageSize', pageSize)
            // verify required parameter 'dictionarySearchRequestDto' is not null or undefined
            assertParamExists('getDictionaries', 'dictionarySearchRequestDto', dictionarySearchRequestDto)
            const localVarPath = `/api/dictionaries/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dictionarySearchRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} dictionaryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDictionary: async (dictionaryId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dictionaryId' is not null or undefined
            assertParamExists('getDictionary', 'dictionaryId', dictionaryId)
            const localVarPath = `/api/dictionaries/{dictionaryId}`
                .replace('{dictionaryId}', encodeURIComponent(String(dictionaryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DictionaryTypeDto} dictionaryType 
         * @param {string} from 
         * @param {string} to 
         * @param {number} [offerInstanceId] 
         * @param {DictionaryCalendarOccupancyKindDto} [kind] Which occupancies the days list (ALL when omitted); status and eventBlocked do not depend on it.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDictionaryTypeCalendarAvailability: async (dictionaryType: DictionaryTypeDto, from: string, to: string, offerInstanceId?: number, kind?: DictionaryCalendarOccupancyKindDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dictionaryType' is not null or undefined
            assertParamExists('getDictionaryTypeCalendarAvailability', 'dictionaryType', dictionaryType)
            // verify required parameter 'from' is not null or undefined
            assertParamExists('getDictionaryTypeCalendarAvailability', 'from', from)
            // verify required parameter 'to' is not null or undefined
            assertParamExists('getDictionaryTypeCalendarAvailability', 'to', to)
            const localVarPath = `/api/dictionary-types/{dictionaryType}/availability`
                .replace('{dictionaryType}', encodeURIComponent(String(dictionaryType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString().substring(0,10) :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString().substring(0,10) :
                    to;
            }

            if (offerInstanceId !== undefined) {
                localVarQueryParameter['offerInstanceId'] = offerInstanceId;
            }

            if (kind !== undefined) {
                localVarQueryParameter['kind'] = kind;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDictionaryTypeCalendarConfigurations: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dictionary-types/calendar-configurations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DictionaryTypeDto} dictionaryType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDictionaryTypeConfiguration: async (dictionaryType: DictionaryTypeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dictionaryType' is not null or undefined
            assertParamExists('getDictionaryTypeConfiguration', 'dictionaryType', dictionaryType)
            const localVarPath = `/api/dictionary-types/{dictionaryType}/calendar`
                .replace('{dictionaryType}', encodeURIComponent(String(dictionaryType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} dictionaryId 
         * @param {UpdateDictionaryRequestDto} updateDictionaryRequestDto Update dictionary request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDictionary: async (dictionaryId: number, updateDictionaryRequestDto: UpdateDictionaryRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dictionaryId' is not null or undefined
            assertParamExists('updateDictionary', 'dictionaryId', dictionaryId)
            // verify required parameter 'updateDictionaryRequestDto' is not null or undefined
            assertParamExists('updateDictionary', 'updateDictionaryRequestDto', updateDictionaryRequestDto)
            const localVarPath = `/api/dictionaries/{dictionaryId}`
                .replace('{dictionaryId}', encodeURIComponent(String(dictionaryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDictionaryRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DictionaryTypeDto} dictionaryType 
         * @param {DictionaryTypeCalendarConfigurationRequestDto} dictionaryTypeCalendarConfigurationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDictionaryTypeConfiguration: async (dictionaryType: DictionaryTypeDto, dictionaryTypeCalendarConfigurationRequestDto: DictionaryTypeCalendarConfigurationRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dictionaryType' is not null or undefined
            assertParamExists('updateDictionaryTypeConfiguration', 'dictionaryType', dictionaryType)
            // verify required parameter 'dictionaryTypeCalendarConfigurationRequestDto' is not null or undefined
            assertParamExists('updateDictionaryTypeConfiguration', 'dictionaryTypeCalendarConfigurationRequestDto', dictionaryTypeCalendarConfigurationRequestDto)
            const localVarPath = `/api/dictionary-types/{dictionaryType}/calendar`
                .replace('{dictionaryType}', encodeURIComponent(String(dictionaryType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dictionaryTypeCalendarConfigurationRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestDictionaryApi - functional programming interface
 */
export const RestDictionaryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestDictionaryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {UpdateDictionaryRequestDto} updateDictionaryRequestDto Add dictionary request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addDictionary(updateDictionaryRequestDto: UpdateDictionaryRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DictionaryCreationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addDictionary(updateDictionaryRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestDictionaryApi.addDictionary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {DictionarySearchRequestDto} dictionarySearchRequestDto Processes search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDictionaries(page: number, pageSize: number, dictionarySearchRequestDto: DictionarySearchRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DictionaryPageableResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDictionaries(page, pageSize, dictionarySearchRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestDictionaryApi.getDictionaries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} dictionaryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDictionary(dictionaryId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DictionaryResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDictionary(dictionaryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestDictionaryApi.getDictionary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DictionaryTypeDto} dictionaryType 
         * @param {string} from 
         * @param {string} to 
         * @param {number} [offerInstanceId] 
         * @param {DictionaryCalendarOccupancyKindDto} [kind] Which occupancies the days list (ALL when omitted); status and eventBlocked do not depend on it.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDictionaryTypeCalendarAvailability(dictionaryType: DictionaryTypeDto, from: string, to: string, offerInstanceId?: number, kind?: DictionaryCalendarOccupancyKindDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DictionaryCalendarAvailabilityDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDictionaryTypeCalendarAvailability(dictionaryType, from, to, offerInstanceId, kind, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestDictionaryApi.getDictionaryTypeCalendarAvailability']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDictionaryTypeCalendarConfigurations(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DictionaryTypeCalendarConfigurationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDictionaryTypeCalendarConfigurations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestDictionaryApi.getDictionaryTypeCalendarConfigurations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DictionaryTypeDto} dictionaryType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDictionaryTypeConfiguration(dictionaryType: DictionaryTypeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DictionaryTypeCalendarConfigurationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDictionaryTypeConfiguration(dictionaryType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestDictionaryApi.getDictionaryTypeConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} dictionaryId 
         * @param {UpdateDictionaryRequestDto} updateDictionaryRequestDto Update dictionary request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDictionary(dictionaryId: number, updateDictionaryRequestDto: UpdateDictionaryRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDictionary(dictionaryId, updateDictionaryRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestDictionaryApi.updateDictionary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DictionaryTypeDto} dictionaryType 
         * @param {DictionaryTypeCalendarConfigurationRequestDto} dictionaryTypeCalendarConfigurationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDictionaryTypeConfiguration(dictionaryType: DictionaryTypeDto, dictionaryTypeCalendarConfigurationRequestDto: DictionaryTypeCalendarConfigurationRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDictionaryTypeConfiguration(dictionaryType, dictionaryTypeCalendarConfigurationRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestDictionaryApi.updateDictionaryTypeConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestDictionaryApi - factory interface
 */
export const RestDictionaryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestDictionaryApiFp(configuration)
    return {
        /**
         * 
         * @param {UpdateDictionaryRequestDto} updateDictionaryRequestDto Add dictionary request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDictionary(updateDictionaryRequestDto: UpdateDictionaryRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<DictionaryCreationResponseDto> {
            return localVarFp.addDictionary(updateDictionaryRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {DictionarySearchRequestDto} dictionarySearchRequestDto Processes search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDictionaries(page: number, pageSize: number, dictionarySearchRequestDto: DictionarySearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<DictionaryPageableResponseDto> {
            return localVarFp.getDictionaries(page, pageSize, dictionarySearchRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} dictionaryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDictionary(dictionaryId: number, options?: RawAxiosRequestConfig): AxiosPromise<DictionaryResponseDto> {
            return localVarFp.getDictionary(dictionaryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DictionaryTypeDto} dictionaryType 
         * @param {string} from 
         * @param {string} to 
         * @param {number} [offerInstanceId] 
         * @param {DictionaryCalendarOccupancyKindDto} [kind] Which occupancies the days list (ALL when omitted); status and eventBlocked do not depend on it.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDictionaryTypeCalendarAvailability(dictionaryType: DictionaryTypeDto, from: string, to: string, offerInstanceId?: number, kind?: DictionaryCalendarOccupancyKindDto, options?: RawAxiosRequestConfig): AxiosPromise<Array<DictionaryCalendarAvailabilityDto>> {
            return localVarFp.getDictionaryTypeCalendarAvailability(dictionaryType, from, to, offerInstanceId, kind, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDictionaryTypeCalendarConfigurations(options?: RawAxiosRequestConfig): AxiosPromise<Array<DictionaryTypeCalendarConfigurationDto>> {
            return localVarFp.getDictionaryTypeCalendarConfigurations(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DictionaryTypeDto} dictionaryType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDictionaryTypeConfiguration(dictionaryType: DictionaryTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<DictionaryTypeCalendarConfigurationDto> {
            return localVarFp.getDictionaryTypeConfiguration(dictionaryType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} dictionaryId 
         * @param {UpdateDictionaryRequestDto} updateDictionaryRequestDto Update dictionary request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDictionary(dictionaryId: number, updateDictionaryRequestDto: UpdateDictionaryRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateDictionary(dictionaryId, updateDictionaryRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DictionaryTypeDto} dictionaryType 
         * @param {DictionaryTypeCalendarConfigurationRequestDto} dictionaryTypeCalendarConfigurationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDictionaryTypeConfiguration(dictionaryType: DictionaryTypeDto, dictionaryTypeCalendarConfigurationRequestDto: DictionaryTypeCalendarConfigurationRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateDictionaryTypeConfiguration(dictionaryType, dictionaryTypeCalendarConfigurationRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestDictionaryApi - interface
 */
export interface RestDictionaryApiInterface {
    /**
     * 
     * @param {UpdateDictionaryRequestDto} updateDictionaryRequestDto Add dictionary request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addDictionary(updateDictionaryRequestDto: UpdateDictionaryRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<DictionaryCreationResponseDto>;

    /**
     * 
     * @param {number} page 
     * @param {number} pageSize 
     * @param {DictionarySearchRequestDto} dictionarySearchRequestDto Processes search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDictionaries(page: number, pageSize: number, dictionarySearchRequestDto: DictionarySearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<DictionaryPageableResponseDto>;

    /**
     * 
     * @param {number} dictionaryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDictionary(dictionaryId: number, options?: RawAxiosRequestConfig): AxiosPromise<DictionaryResponseDto>;

    /**
     * 
     * @param {DictionaryTypeDto} dictionaryType 
     * @param {string} from 
     * @param {string} to 
     * @param {number} [offerInstanceId] 
     * @param {DictionaryCalendarOccupancyKindDto} [kind] Which occupancies the days list (ALL when omitted); status and eventBlocked do not depend on it.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDictionaryTypeCalendarAvailability(dictionaryType: DictionaryTypeDto, from: string, to: string, offerInstanceId?: number, kind?: DictionaryCalendarOccupancyKindDto, options?: RawAxiosRequestConfig): AxiosPromise<Array<DictionaryCalendarAvailabilityDto>>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDictionaryTypeCalendarConfigurations(options?: RawAxiosRequestConfig): AxiosPromise<Array<DictionaryTypeCalendarConfigurationDto>>;

    /**
     * 
     * @param {DictionaryTypeDto} dictionaryType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDictionaryTypeConfiguration(dictionaryType: DictionaryTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<DictionaryTypeCalendarConfigurationDto>;

    /**
     * 
     * @param {number} dictionaryId 
     * @param {UpdateDictionaryRequestDto} updateDictionaryRequestDto Update dictionary request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateDictionary(dictionaryId: number, updateDictionaryRequestDto: UpdateDictionaryRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {DictionaryTypeDto} dictionaryType 
     * @param {DictionaryTypeCalendarConfigurationRequestDto} dictionaryTypeCalendarConfigurationRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateDictionaryTypeConfiguration(dictionaryType: DictionaryTypeDto, dictionaryTypeCalendarConfigurationRequestDto: DictionaryTypeCalendarConfigurationRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * RestDictionaryApi - object-oriented interface
 */
export class RestDictionaryApi extends BaseAPI implements RestDictionaryApiInterface {
    /**
     * 
     * @param {UpdateDictionaryRequestDto} updateDictionaryRequestDto Add dictionary request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addDictionary(updateDictionaryRequestDto: UpdateDictionaryRequestDto, options?: RawAxiosRequestConfig) {
        return RestDictionaryApiFp(this.configuration).addDictionary(updateDictionaryRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} page 
     * @param {number} pageSize 
     * @param {DictionarySearchRequestDto} dictionarySearchRequestDto Processes search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDictionaries(page: number, pageSize: number, dictionarySearchRequestDto: DictionarySearchRequestDto, options?: RawAxiosRequestConfig) {
        return RestDictionaryApiFp(this.configuration).getDictionaries(page, pageSize, dictionarySearchRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} dictionaryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDictionary(dictionaryId: number, options?: RawAxiosRequestConfig) {
        return RestDictionaryApiFp(this.configuration).getDictionary(dictionaryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DictionaryTypeDto} dictionaryType 
     * @param {string} from 
     * @param {string} to 
     * @param {number} [offerInstanceId] 
     * @param {DictionaryCalendarOccupancyKindDto} [kind] Which occupancies the days list (ALL when omitted); status and eventBlocked do not depend on it.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDictionaryTypeCalendarAvailability(dictionaryType: DictionaryTypeDto, from: string, to: string, offerInstanceId?: number, kind?: DictionaryCalendarOccupancyKindDto, options?: RawAxiosRequestConfig) {
        return RestDictionaryApiFp(this.configuration).getDictionaryTypeCalendarAvailability(dictionaryType, from, to, offerInstanceId, kind, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDictionaryTypeCalendarConfigurations(options?: RawAxiosRequestConfig) {
        return RestDictionaryApiFp(this.configuration).getDictionaryTypeCalendarConfigurations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DictionaryTypeDto} dictionaryType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDictionaryTypeConfiguration(dictionaryType: DictionaryTypeDto, options?: RawAxiosRequestConfig) {
        return RestDictionaryApiFp(this.configuration).getDictionaryTypeConfiguration(dictionaryType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} dictionaryId 
     * @param {UpdateDictionaryRequestDto} updateDictionaryRequestDto Update dictionary request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateDictionary(dictionaryId: number, updateDictionaryRequestDto: UpdateDictionaryRequestDto, options?: RawAxiosRequestConfig) {
        return RestDictionaryApiFp(this.configuration).updateDictionary(dictionaryId, updateDictionaryRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DictionaryTypeDto} dictionaryType 
     * @param {DictionaryTypeCalendarConfigurationRequestDto} dictionaryTypeCalendarConfigurationRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateDictionaryTypeConfiguration(dictionaryType: DictionaryTypeDto, dictionaryTypeCalendarConfigurationRequestDto: DictionaryTypeCalendarConfigurationRequestDto, options?: RawAxiosRequestConfig) {
        return RestDictionaryApiFp(this.configuration).updateDictionaryTypeConfiguration(dictionaryType, dictionaryTypeCalendarConfigurationRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

